/*
 * buecherglanz — 2026-09-23
 * Grund: Der freigegebene Entwurf (Runde 4) zeigt die Produktgalerie am Handy mit Punkten unter dem
 *   Bild (5 px, #D9CBB0). Das Theme liefert dort Pfeile und einen Zähler „1/6“; eine Einstellung für
 *   Punkte gibt es nicht.
 * Funktion: ersetzt die Pfeil-/Zähler-Leiste der Produktgalerie am Handy durch Punkte.
 *   Nutzt die vorhandene Theme-Komponente <slider-component>: Klick scrollt zum Bild, das
 *   Theme-Ereignis „slideChanged“ hält den aktiven Punkt aktuell, ein eigener Scroll-Listener
 *   dient als Rückfallebene. Kein Eingriff in global.js oder in main-product.liquid
 *   (Theme-Update-sicher).
 * Barrierefreiheit: echte <button>-Elemente mit aria-label (vorhandene Übersetzungsschlüssel) und
 *   aria-current; Trefferfläche 24 × 24 px nach WCAG 2.2, der sichtbare Punkt bleibt 5 px.
 * Rückbau: Block „Galerie-Punkte“ in templates/product.json deaktivieren.
 */
(function () {
  const start = () => {
    const cfg = document.querySelector('[data-bg-gallery-dots]');
    if (!cfg) return;
    const slider = document.querySelector('media-gallery slider-component.slider-mobile-gutter');
    if (!slider) return;
    const list = slider.querySelector('ul.slider--mobile');
    const buttons = slider.querySelector('.slider-buttons');
    if (!list || !buttons || buttons.dataset.bgDots) return;

    const slides = Array.from(list.children);
    if (slides.length < 2) return;

    const labelLoad = cfg.dataset.labelLoad || '';
    const labelOf = cfg.dataset.labelOf || '/';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const dots = document.createElement('div');
    dots.className = 'bg-gdots';

    slides.forEach((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bg-gdots__dot';
      dot.setAttribute('aria-label', (labelLoad + ' ' + (i + 1) + ' ' + labelOf + ' ' + slides.length).trim());
      dot.addEventListener('click', () => {
        list.scrollTo({
          left: slide.offsetLeft - list.offsetLeft,
          behavior: reduce.matches ? 'auto' : 'smooth',
        });
      });
      dots.appendChild(dot);
    });

    buttons.dataset.bgDots = 'true';
    buttons.after(dots);

    const setActive = (page) => {
      const idx = Math.min(Math.max(page - 1, 0), slides.length - 1);
      Array.from(dots.children).forEach((dot, i) => {
        dot.classList.toggle('is-active', i === idx);
        if (i === idx) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    setActive(1);
    slider.addEventListener('slideChanged', (event) => {
      if (event.detail && event.detail.currentPage) setActive(event.detail.currentPage);
    });

    let ticking = false;
    list.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const step = slides[0].getBoundingClientRect().width + 8;
          if (step > 0) setActive(Math.round(list.scrollLeft / step) + 1);
        });
      },
      { passive: true }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();